import 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';
import moment$1 from 'moment';

function Duration(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);
  if (!value) return null;
  if (typeof value === 'string') return value;
  value = moment$1.duration(value, props.unit);
  return !value ? null : value.humanize();
}

Duration.defaultProps = {
  defaultValue: null,
  unit: 'seconds'
};
Duration.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  unit: PropTypes$1.oneOf(['seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years'])
};
var Duration$1 = observer(Duration);

export default Duration$1;
//# sourceMappingURL=Duration.js.map
